import Layout from '@/views/layout';

const auditRouter = {
  path: '/audit',
  name: 'Audit',
  component: Layout,
  meta: { title: '订单审核', roles: [0, 4, 3], noCache: true },
  redirect: { name: 'AuditList' },
  children: [
    {
      path: 'auditList',
      name: 'AuditList',
      component: () => import('@/views/audit'),
      meta: { title: '订单审核', roles: [0, 4, 3], noCache: true }
    }
  ]
}

export default auditRouter;